<template>
  <div v-loading="loading" v-if="show && question.isShow" class="question-item">
    <div class="question-title">
      <i v-if="question.tipColor == 1">
        <img src="./image/red.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 2">
        <img src="./image/yellow.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 3">
        <img src="./image/green.png" alt="">
      </i>
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题：</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <div class="qs-img-preview">
      <img :src="question.pictureUrl" alt="">
    </div>
    <div class="option-container">
      <span>{{ question.scaleConfig.minText }}</span>
      <div class="question-option" v-for="(item,index) in question.options" :key="index">
        <div class="question-option-container">
          <div @click="selectHandler(item,index)" class="option-title">
            <i v-if="!item.selected" class="iconfont iconselect-normal"></i>
            <i v-else class="iconfont iconselect-active"></i>
            <span :class="{active: item.selected}">{{ item.optionTitle }}</span>
          </div>
          <div class="option-other">
            <input  type="text" v-model="item.fillContent"
                   v-if="item.allowFill && item.selected">
            <!--<van-field v-if="item.allowUpload && item.selected" name="uploader">-->
            <!--<template #input>-->
            <!--<van-uploader @delete="deleteHandler" multiple :after-read="afterRead" v-model="uploader"-->
            <!--:max-count="5"/>-->
            <!--</template>-->
            <!--</van-field>-->
            <!--<input @change="getFile" type="file" multiple="multiple" v-if="item.allowUpload && item.selected">-->
          </div>
        </div>
      </div>
      <span>{{ question.scaleConfig.maxText }}</span>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'question-single',
  props: {
    question: {required: true},
    displaySetting: {required: true},
    jumpSetting: {required: true},
    questionList: {required: true},
    patientId: {required: true}
  },
  data() {
    return {
      loading: false,
      show: false,
      currentIndex: null,
      fileList: [],
      uploader: [],
      imageList: [],
      jumpPageNumber: null
    }
  },
  beforeDestroy() {
    // console.log(this.currentPage, this.question.pageNumber);
    // if (this.$route.path == '/callPatient' && this.currentPage == this.question.pageNumber) {
    //   console.log('destory');
    //   this.deleteAnswer()
    // }
  },
  created() {
    this.getAnswer()
    this.getPicture()
  },
  computed: {
    ...mapGetters([
      'currentPage'
    ])
  },
  watch: {
    'question.isShow': {
      handler(val,oldVal) {
        if(!val) {
          console.log(111);
          this.disabledShowOrHide(this.currentIndex, false)
          this.question.options.forEach((item,index) => {
            console.log(item);
            if(item.selected) {
              this.selectHandler(item,index)
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getPicture() {
      if (this.question.pictureUrl && this.question.pictureUrl.indexOf('http') == -1) {
        this.$store.dispatch('getPicture', {url: [this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },
    selectHandler(item, index) {
      if (item.selected) {
        item.selected = false
        this.question.value = {}
      } else {
        this.question.options.forEach(v => {
          v.selected = false
        })
        item.selected = true
      }
      // this.saveAnswer()
      // console.log(this.currentIndex, index + 1)
      if (this.currentIndex) {
        this.disabledShowOrHide(this.currentIndex, false)
        this.disabledShowOrHide(index + 1, true)
        if (this.currentIndex == index + 1) {
          this.disabledShowOrHide(this.currentIndex, false)
          this.jumpShowOrHide(this.currentIndex, false)
        } else {
          this.jumpShowOrHide(index + 1, true)
          this.jumpShowOrHide(this.currentIndex, false)
        }
      } else {
        this.disabledShowOrHide(index + 1, true)
        this.jumpShowOrHide(index + 1, true)
      }
      this.question.value = item
      if (item.selected) {
        this.currentIndex = index + 1
      } else {
        this.currentIndex = null
        this.question.value = ''
      }
    },

    jumpShowOrHide(index, boolean) {
      if (this.jumpSetting.length) {
        if (boolean) {
          var arr = this.jumpSetting.filter(item => item.optionId == index)
          arr.forEach(it => {
            this.$store.dispatch('queryQuestionPageListAsync', {
              questionPageResp: {
                questionInfoId: it.questionId,
                questionnaireNewId: this.question.questionnaireNewId
              }
            })
                .then(res => {
                  this.jumpPageNumber = res.retValue[0].pageNumber
                  this.$emit('setJump', this.jumpPageNumber)
                })
          })
        } else {
          this.$emit('clearJump')
        }
      } else {
        return
      }
    },
    disabledShowOrHide(index, boolean) {
      var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
        return it.questionId
      }).flat(9) //平铺数组 兼容处理
      if (disabledList) {
        disabledList.forEach(v => {
          console.log(v)
          if (this.questionList.find(item => item.id == v)) {
            this.questionList.find(item => item.id == v).isShow = boolean
          }
        })
      }
    },
    deleteHandler() {
      this.imageList = []
      if (!this.uploader.length) {
        this.question.options[this.currentIndex - 1].uploadImage = ''
      } else {
        this.afterRead(this.uploader)
      }
    },
    afterRead(file) {
      if (Object.prototype.toString.call(file) == '[object Array]') {
        file.forEach(v => {
          // v.status = 'uploading'
          this.uploadImage(v.file)
              .then((res) => {
                // v.status = 'done'
                this.imageList.push(res.name)
                this.question.options[this.currentIndex - 1].uploadImage = this.imageList.join(',')
              })
              .catch(() => {
                v.status = 'failed'
              })
        })
      } else {
        // file.status = 'uploading'
        this.uploadImage(file.file)
            .then((res) => {
              // file.status = 'done'
              this.imageList.push(res.name)
              this.question.options[this.currentIndex - 1].uploadImage = this.imageList.join(',')
            })
            .catch(() => {
              file.status = 'failed'
            })
      }
    },
    uploadImage(file) {
      return new Promise((resolve, reject) => {
        let uploadData = {}
        uploadData.file = file
        uploadData.url = file.name
        uploadData.objName = `question/uploadImg/${Math.floor(Math.random()) + new Date().getTime()}`
        this.$store.dispatch('put', uploadData)
            .then(res => {
              if (res.res.status == 200) {
                resolve(res)
              }
            })
            .catch((rej) => {
              reject()
            })
      })
    },
    checkIsFill() {
      if (this.question.isShow) {
        if (this.question.isMust) {
          if (this.question.value) {
            return true
          } else {
            return false
          }

        } else {
          return true
        }
      } else {
        return true
      }
    },
    getAnswer() {
      this.displaySetting.map(item => {
        if (item.newOptionId) {
          item.optionId = this.question.options.findIndex(_it => _it.id == item.newOptionId) + 1
          return item
        }
      })
      if (this.question.value) {
        var optionIndex = this.question.options.findIndex(item => item.id == this.question.value.id)
        console.log('optionIndex', this.question.options[optionIndex])
        this.currentIndex = optionIndex + 1
        if (this.question.options[optionIndex]) {
          this.question.options[optionIndex].selected = true
          console.log(this.question.value.fillContent)
          this.question.options[optionIndex].fillContent = this.question.value.fillContent
          this.disabledShowOrHide(optionIndex + 1, true)
          if (this.jumpSetting.length) {
            console.log(this.jumpSetting.find(item => item.optionId == optionIndex + 1))
            if (this.jumpSetting.find(item => item.optionId == optionIndex + 1)) {
              var questionId = this.jumpSetting.find(item => item.optionId == optionIndex + 1).questionId
              this.$store.dispatch('queryQuestionPageListAsync', {
                questionPageResp: {
                  questionInfoId: questionId,
                  questionnaireNewId: this.question.questionnaireNewId
                }
              })
                  .then(res => {
                    this.jumpPageNumber = res.retValue[0].pageNumber
                    this.$emit('setJump', this.jumpPageNumber)
                  })
            }

          }
        }

        this.show = true
        //如果有跳转逻辑
        // this.question.options.find(item => item.id == this.question.value.id).selected = true
      } else {
        this.show = true
      }
    },
    saveAnswer() {
      console.log('save');
      this.loading = true
      return new Promise((resolve => {
        var answer = this.question.options.find(item => item.selected) || ""
        console.log("answer", answer);
        var params = {
          operatorId: localStorage.getItem('huidrUserId'),
          questionInfo: this.question.id,
          questionnaireNewId: this.question.questionnaireNewId,
          answerInfo: JSON.stringify(answer),
          id: this.question.patientAnswerInfoId || null,
          patientId: this.patientId,
          questionType: this.question.type || null,
        }
        if (this.$route.query.abnormal == '5') {
          params.isRecord = true
        } else {
          params.isRecord = false
        }
        if (this.question.patientAnswerInfoId) {
          this.$store.dispatch('updateQuestionAnswer', params)
              .then(() => {
                this.loading = false

                resolve()
              })
        } else {
          this.$store.dispatch('saveQuestionAnswer', params)
              .then((res) => {
                this.question.patientAnswerInfoId = res.retValue.id
                this.loading = false

              })
        }
      }))
    },
    deleteAnswer() {
      var params = {
        questionNewId: this.question.questionnaireNewId,
        answerInfoId: this.question.patientAnswerInfoId || null,
      }
      if (this.question.patientAnswerInfoId) {
        this.$store.dispatch('deleteQuestionAnswer', params)
            .then(res => {
              if (res.status == 0) {
                this.question.patientAnswerInfoId = null
                this.question.value = null
                this.question.answerInfo = null
                this.question.options.forEach(item => {
                  item.selected = false
                })
              } else {
              }
            })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "questionCommon";

.option-container {
  display: flex;
}

.question-option {
  .option-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 20px;

    span {
      font-size: 16px;
    }
  }

  .option-other {

  }
}

</style>